import _defineProperty from "/builds/thema-developers/my-thema-project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import MatImage from "./MatImage.vue";
let Aste = class Aste extends Vue {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "sicuroCambioMateriale", false);

    _defineProperty(this, "matFiltro", this.templesColor && this.templesColor.METALTEMPLE == "1" ? "MT" : "PL");

    _defineProperty(this, "findTempleColor", "");

    _defineProperty(this, "activeTemple", this.templesColor != null ? this.templesColor : null);

    _defineProperty(this, "materialToChange", null);

    _defineProperty(this, "templeToActivate", null);
  }

  get temples() {
    return this.$store.state.configurator.aste.allColors;
  }

  get tipoAbbellitore() {
    return this.$store.state.configurator.tipoAbbellitore;
  }

  set tipoAbbellitore(v) {
    this.$store.state.configurator.tipoAbbellitore = v;
  }

  get materialePerFiltro() {
    return this.matFiltro;
  }

  set materialePerFiltro(m) {
    this.matFiltro = m; // Aggiorno variabile
    // Controllo se la configurazione è valida

    let at = this.activeTemple;
    let a = [];

    if (at != null) {
      a = this.temples.filter(t => {
        let mat = m == "PL" ? "0" : "1";
        return at?.U_THE_COLORE == t.U_THE_COLORE && at?.U_THE_LUNGASTA == t.U_THE_LUNGASTA && t.METALTEMPLE == mat;
      });
    } // Se la configurazione è valida


    if (a.length > 0) {
      if (this.matFiltro == "MT" && this.presentiPersonalizzazioniAste) {
        // Se ho personalizzazioni attive ed il materiale del filtro è Metallo, chiedo all'utente se è sicuro di voler cambiare materiale ed eliminare le personalizzazioni sulle aste
        this.materialToChange = m;
        this.templeToActivate = a[0];
        this.sicuroCambioMateriale = true;
      } else {
        // Altrimenti setto definitivamente il materiale selezionato
        this.setTemplesMaterial(m);
        this.setActiveTemple(a[0]);
      }
    } // Se la configurazione non è valida, mantengo la variabile matFiltro per
    // - eseguire il filtraggio dei colori
    // - settare il materiale giusto quando l'utente sceglierà un colore valido per il materiale selezionato

  }

  get sizesAvailables() {
    let availableSizes = [];

    for (let i = 0; i < this.filteredTemples.length; i++) {
      //   if (this.materialePerFiltro == "PL") {
      //     if (
      //       this.temples[i].METALTEMPLE == 0 &&
      //       availableSizes.indexOf(this.temples[i].U_THE_LUNGASTA) < 0
      //     ) {
      //       availableSizes.push(this.temples[i].U_THE_LUNGASTA);
      //     }
      //   } else {
      if (this.temples[i].METALTEMPLE == 1 && availableSizes.indexOf(this.filteredTemples[i].U_THE_LUNGASTA) < 0) {
        availableSizes.push(this.filteredTemples[i].U_THE_LUNGASTA);
      } // }

    }

    return availableSizes;
  }

  get filteredTemples() {
    let result = this.temples;
    if (this.$store.state.configurator.frontale != null) result = result.filter(t => {
      // return _.includes(t.U_THE_COLORE, q);
      return t.U_THE_LINEA == this.$store.state.configurator.frontale.U_THE_LINEA;
    });

    if (this.materialePerFiltro) {// result = result.filter((t: Temple) => {
      //   if (this.materialePerFiltro == "PL") {
      //     return t.METALTEMPLE == "0";
      //   } else {
      //     return t.METALTEMPLE == "1";
      //   }
      //   //return t.materiale == this.materiale
      // });
    }

    if (this.misuraAste) {// result = result.filter((t: Temple) => {
      //   return t.U_THE_LUNGASTA == this.misuraAste;
      // });
    }

    let t = result.filter(t => {
      return t.U_THE_COLORE == this.templesColor?.U_THE_COLORE && t.U_THE_COL_TYPE1 == this.templesColor.U_THE_COL_TYPE1;
    })[0];

    if (t != null) {
      this.setActiveTemple(t);
    } else {
      t = result.filter(t => {
        return t.U_THE_COLORE == "PL0001";
      })[0];
      this.setActiveTemple(t);
    }

    return result;
  }

  get templesColor() {
    return this.$store.state.configurator.coloreAste;
  }

  get misuraAste() {
    return this.$store.state.configurator.misuraAste;
  }

  set misuraAste(ma) {
    this.$store.commit("configurator/setTemplesSize", ma);
  }

  get finituraAste() {
    return this.$store.state.configurator.finituraAste;
  }

  set finituraAste(fa) {
    this.$store.commit("configurator/setTemplesFinishing", fa);
  }

  get materiale() {
    return this.$store.state.configurator.templesMaterial;
  }

  set materiale(m) {
    this.$store.commit("configurator/setTemplesMaterial", m);
  }

  get coloreMetalloAste() {
    return this.$store.state.configurator.coloreMetalloAste;
  }

  set coloreMetalloAste(c) {
    if (this.materiale == "MT") this.$store.commit("configurator/setTemplesMetalColor", c);
  }

  get presentiPersonalizzazioniAste() {
    return this.$store.state.configurator.aste.extSxName != "" || this.$store.state.configurator.aste.extSxNameColor != "" || this.$store.state.configurator.aste.intSxName != "" || this.$store.state.configurator.aste.intSxNameColor != "" || this.$store.state.configurator.aste.extDxName != "" || this.$store.state.configurator.aste.extDxNameColor != "" || this.$store.state.configurator.aste.intDxName != "" || this.$store.state.configurator.aste.intDxNameColor != "";
  } // noTempleAvailable() {
  //   if (this.filteredTemples.length == 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }


  setTemplesColor(t) {
    this.$store.commit("configurator/setTemplesColor", t);
  }

  setTemplesMaterial(tm) {
    this.$store.commit("configurator/setTemplesMaterial", tm);
  }

  unsetTemplesMetalColor() {
    this.$store.commit("configurator/unsetTemplesMetalColor");
  }

  resetPersonalizzazioniAste() {
    this.$store.commit("resetPersonalizzazioniAste");
  }
  /**
   * Verifica se bisogna chiedere all'utente conferma nel caso stia selezionando metallo mentre ha personalizzazioni attive sulle aste
   */


  tryActivateTemple(t) {
    if (this.matFiltro == "MT" && this.presentiPersonalizzazioniAste) {
      this.materialToChange = this.materiale;
      this.templeToActivate = t;
      this.sicuroCambioMateriale = true;
    } else {
      this.setActiveTemple(t);
    }
  }

  setActiveTemple(t) {
    this.activeTemple = t;
    this.setTemplesColor(t);

    if (t.U_THE_LUNGASTA != this.misuraAste) {
      this.misuraAste = t.U_THE_LUNGASTA;
    }
  }

  canShowMetalColors() {
    return (this.templesColor && this.templesColor.METALTEMPLE == "1") == 1;
  }

  materialChanged(newVal) {
    let at = this.activeTemple;
    let a = [];

    if (at != null) {
      a = this.temples.filter(t => {
        let m = newVal == "PL" ? 0 : 1;
        return at?.U_THE_COLORE == t.U_THE_COLORE && at?.U_THE_LUNGASTA == t.U_THE_LUNGASTA && t.METALTEMPLE == m;
      });
    }

    if (a.length > 0) {
      this.tryActivateTemple(a[0]);
    }

    if (newVal == "PL") {
      this.unsetTemplesMetalColor();
    } else if (newVal == "MT") {
      this.coloreMetalloAste = this.coloreMetalloAste == null ? "PRO0000272" : this.coloreMetalloAste; //this.coloreMetalloAste = 'PRO0000272';
    }
  }

  misuraAsteChanged(newVal) {
    /*
                                  se ho un'asta attiva e cambia la misura
                                  sostituisco all'asta attiva una con
                                  stesso colore, stesso materiale e misura selezionata
                                */
    let at = this.activeTemple;

    if (at != null) {
      let a = this.temples.filter(t => {
        return t.U_THE_COLORE == at?.U_THE_COLORE && t.METALTEMPLE == at?.METALTEMPLE && t.U_THE_LUNGASTA == newVal;
      });

      if (a.length > 0) {
        this.setActiveTemple(a[0]); // } else {
        //   this.noTempleAvailable = true;
      }
    }
  }

  activeTempleChanged() {
    return this.setTemplesMaterial(this.materiale);
  }

  templesColorChanged(newVal, oldVal) {
    if (oldVal) {
      if (newVal.U_THE_COLORE != oldVal.U_THE_COLORE && newVal.U_THE_COL_TYPE1 != oldVal.U_THE_COL_TYPE1) {
        this.activeTemple = newVal; // Ora che l'utente ha selezionato un colore valido, setto il materiale corrispondente al tab in cui si trova

        this.materiale = this.materialePerFiltro;
      }
    } else {// this.activeTemple = this.filteredTemples.filter((t: Temple) => {
      //   return (
      //     t.U_THE_COLORE == this.activeTemple?.U_THE_COLORE &&
      //     t.U_THE_COL_TYPE1 == this.activeTemple.U_THE_COL_TYPE1
      //   );
      // })[0];
    }
  }

};

__decorate([Watch("materiale")], Aste.prototype, "materialChanged", null);

__decorate([Watch("misuraAste")], Aste.prototype, "misuraAsteChanged", null);

__decorate([Watch("activeTemple")], Aste.prototype, "activeTempleChanged", null);

__decorate([Watch("templesColor")], Aste.prototype, "templesColorChanged", null);

Aste = __decorate([Component({
  components: {
    MatImage
  }
})], Aste);
export default Aste;